import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-59">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-60">
        <img src="https://cdn.magicpatterns.com/uploads/2XspsnfX9BAsUeu65Hbyjq/Presentacion_-_Sanacion_Emocional_Un_Viaje_Interior.jpg" alt="Atardecer en un acantilado" className="w-full h-full object-cover object-center" data-id="element-61" />
        <div className="absolute inset-0 bg-brand-dark/55 mix-blend-multiply" data-id="element-62"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/20 via-brand-dark/40 to-brand-dark" data-id="element-63"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-64">
        <FadeIn data-id="element-65">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-brand-offwhite leading-tight mb-6" data-id="element-66">
            Después del Engaño: La Hoja de Ruta de 7 Pasos para Recuperar tu Paz
            y Decidir tu Futuro.
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-67">
          <h2 className="text-lg sm:text-xl md:text-2xl text-brand-offwhite/90 font-sans font-light max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-68">
            Detén la obsesión, elimina la parálisis mental y descubre si tu
            relación tiene salvación o si es momento de marcharte sin culpa.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-69">
          <CTAButton scrollToId="offer-block" data-id="element-70" />
        </FadeIn>
      </div>
    </section>;
}